<template>
    <div class="dashboard-change col-lg-12">
        <tabs :options="{ useUrlFragment: false }">
            <tab name="Change Password">
                <form @submit.prevent="changePassword()">
                    <div class="form-group form-sm-right">
                        <div class="input-group" v-if="validationErrors.length">
                            <p v-for="validationError in validationErrors" :key="validationError.index"><label class="text-danger" v-text="validationError" /></p>
                        </div>
                    </div>

                    <div class="form-sm-left">
                        <div class="form-group">
                            <div class="input-group">
                                <label><b>{{ $t("message.currentPassword") }} *</b></label>
                                <input name="password" type="password" v-model="changePasswordData.CurrentPassword" class="form-control" ref="profileCurrentPassword" :disabled="isCSR" autofocus />
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="input-group">
                                <label><b>{{ $t("message.newPassword") }} *</b></label>
                                <input name="password" type="password" v-model="changePasswordData.NewPassword" class="form-control" :disabled="isCSR" />
                                <div id="passwordHelpInline" class="helper-text" v-if="passwordRules.length">
                                    <span>Password must contain at least:</span>
                                    <span>{{ passwordRules }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="input-group">
                                <label><b>{{ $t("message.confirmNewPassword") }} *</b></label>
                                <input name="password" type="password" v-model="changePasswordData.ConfirmNewPassword" class="form-control" :disabled="isCSR" />
                            </div>
                        </div>

                        <div class="form-group">
                            <p>
                                <button id="btnChangePassword" type="submit" class="btn btn-sm btn-primary" 
                                            @click.prevent="changePassword()" :disabled="inputNotValid">{{ $t("message.submit") }}</button>
                                <button id="btnCancelPassword" type="submit" class="btn btn-sm btn-primary" @click.prevent="cancel()">{{ $t("message.cancel") }}</button>
                            </p>
                        </div>
                    </div>  
                    <div class="clear"></div>
                </form>
            </tab>
            <tab name="Change Username">
                <ChangeUsername></ChangeUsername>
            </tab>
        </tabs>
    </div>
</template>

<script>
import axios from "axios";
import ChangeUsername from '@/components/dashboard/ChangeUsername';

export default {
    name: 'ChangePassword',
    components: {
        ChangeUsername
    },
    data() {
        return {
            changePasswordData: {
                CurrentPassword: '',
                NewPassword: '',
                ConfirmNewPassword: '',
                ResponseType: '',
                Message: ''
            },
            validationErrors: []
        }
    },
    mounted() {          
        this.$nextTick(() => {
            this.$refs.profileCurrentPassword.focus();
        });
    },
    methods: {
        changePassword() {
            axios({
                method: "POST",
                url: this.$httpAxiosBaseUrl() + "Profile/ChangePassword",
                data: {
                    changePasswordData: this.changePasswordData
                }
            }).then(result => {
                var response = result.data;
                if (response !== '') {
                    var responseType = response.ResponseType;
                    var messageToDisplay = response.Message;

                    if (responseType === this.$ResponseType.Error) {
                        this.showMessage(messageToDisplay, responseType);
                    } else {
                        this.showMessage(messageToDisplay, responseType);
                        this.changePasswordData = [];

                        this.$router.push({ name: "Home" });
                    }
                } else {
                    this.showMessage("An error has occurred. Password has not been saved, please try again.", this.$ResponseType.Error);
                }
            }, error => {
                console.log(error)
            })
        },
        cancel() {
            this.$router.push({ name: "Home" });
        },
        showMessage(message, type) {
            this.$toasted.show(message, {type: type, position: 'top-center', duration: '2000'});
            this.$announcer.set(message);
        }
    },
    computed: {
        passwordRules() {
            if (this.$store.getters.getPasswordRules.length == 0) {
                // Fetch Password Rules
                axios({
                    method: "GET",
                    url: this.$httpAxiosBaseUrl() + "Profile/GetPasswordRules"
                }).then(result => {
                    var response = result.data;
                    if (response !== '') {
                        this.$store.commit('setPasswordRules', response);
                    }
                }, error => {
                    console.log(error);
                })
            }

            return this.$store.getters.getPasswordRules;
        },
        inputNotValid() {
            // No need to validate input if CSR is viewing this component as CSR's are not allowed to update password
            if (!this.$store.getters.getIsCSR) {
                this.validationErrors = [];
                var inputFieldsEmpty = false;
                var passwordsDontMatch = false;

                if (this.changePasswordData.CurrentPassword.length === 0 || this.changePasswordData.NewPassword.length === 0 || this.changePasswordData.ConfirmNewPassword.length === 0) {
                    this.validationErrors.push("Current Password, New Password and Confirm New Password are required fields.");
                    inputFieldsEmpty = true;
                }

                if (this.changePasswordData.NewPassword !== this.changePasswordData.ConfirmNewPassword) {
                    this.validationErrors.push("Passwords don't match");
                    passwordsDontMatch = true;
                }

                return inputFieldsEmpty || passwordsDontMatch;
            } else {
                return true;
            }            
        },
        isCSR() {
            return this.$store.getters.getIsCSR;
        }
    }
}
</script>

<style>
.form-sm-right {
    width: 50%;
    float: right;
    padding-top: 20px;
}

.form-sm-left {
    width: 48%;
}

.tabs-component-tab a {
    color: #999 !important;
}

.tabs-component-tab.is-active a {
    color: #428bca !important;
}

.tabs-component-tab-a:hover {
    color: #2a6496 !important;
}

@media only screen and (max-width : 768px) {
    .form-sm-right, .form-sm-left {
        width: 100%;        
    }

    .form-sm-right {
        float: none;
        padding-top: 10px;
    }
}
</style>